import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {Alert} from '../model/alert';

@Injectable({
  providedIn: 'root',
})
export class AlertsApiService {
  constructor(private http: HttpClient) {}

  private get url() {
    return `${environment.apiUrl}/activities`;
  }

  public get(): Observable<Alert[]> {
    return this.http.get<Alert[]>(`${this.url}/user`);
  }

  public getCount(): Observable<{count: number}> {
    return this.http.get<{count: number}>(`${this.url}/user/count`);
  }

  public dismiss(alertId: string): Observable<void> {
    return this.http.put<void>(`${this.url}/${alertId}/dismiss`, {});
  }
}
